/* src/app/shared/components/mce-editor/link-editor-dialog.component.scss */
.link-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #616161;
  margin-bottom: 4px;
}
.link-input {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  font-size: 14px;
}
.link-input:focus {
  outline: none;
  border-color: #1565c0;
}
/*# sourceMappingURL=link-editor-dialog.component-LVVXMA37.css.map */
